export default __webpack_public_path__ + "static/media/plus-circle.31238bab.svg";